export default {
  en: {
    comment: {
      zero: '0 comments',
      one: '%{count} comment',
      other: '%{count} comments',
    },

    like: {
      one: '%{lastPerson}',
      other: '%{lastPerson} and %{restCount} others',
    },
    be_the_first: 'Be the first!',
  },
};
